/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Rtl_FormattingInputs */



/**
* | output |
* | --- |
* | "RTL Formatting" |
*
* @param {Subtitle_Export_Rtl_FormattingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_rtl_formatting = /** @type {((inputs?: Subtitle_Export_Rtl_FormattingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Rtl_FormattingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formatage RTL")
	if (locale === "de") return /** @type {LocalizedString} */ ("RTL-Formatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formattazione RTL")
	if (locale === "ru") return /** @type {LocalizedString} */ ("RTL-форматирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato RTL")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("RTL格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("RTLフォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आरटीएल प्रारूपण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação RTL")
	return /** @type {LocalizedString} */ ("RTL Formatting")
});